import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {fetchSchedulingLinksAsyncAction} from '../../../../store/data/schedulingLinks/schedulingLinksActions';
import {getSortedPermanentSchedulingLinks} from '../../../../store/data/schedulingLinks/schedulingLinksSelectors';
import {SchedulingLinksDropdown} from './schedulingLinksDropdown';

/*
 * Props.
 */

interface SchedulingLinksDropdownContainerProps {}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SchedulingLinksDropdownContainerProps>()(() => ({
  schedulingLinks: getSortedPermanentSchedulingLinks,
}));

const mapDispatchToProps = makeMapDispatchToProps<SchedulingLinksDropdownContainerProps>()(() => ({
  fetchSchedulingLinksAsync: fetchSchedulingLinksAsyncAction,
}));

export const SchedulingLinksDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchedulingLinksDropdown);
